import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Global Selectors
// @ts-ignore
import { selectSpraySchemaExists } from 'services/schemas/selectors';

export interface OwnProps {
    children: React.ReactElement;
}

interface ConnectedProps {
    spraySchemaExists?: boolean;
}

type Props = OwnProps & ConnectedProps;

/**
 * A component to wrap around content only visible to organisations that have a the spray feature enabled.
 */
export class SpraySchemaExistsGate extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { children, spraySchemaExists } = this.props;
        if (!spraySchemaExists) {
            return null;
        }
        return children;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    spraySchemaExists: selectSpraySchemaExists
});

export default connect(mapStateToProps)(SpraySchemaExistsGate);
